import React, { memo, Suspense, useEffect } from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'

import { Box } from '@material-ui/core'

import InternalServerError from '~/components/Error/InternalServerError'
import NotFound from '~/components/Error/NotFound'
import ErrorUnauthorized from '~/components/Error/Unauthorized'
import Loading from '~/components/Loading'
import Streamax from '~/modules/Streamax'
import DetailMapPublicPage from '~/pages/DetailMapPublic'
import NoPermissionPage from '~/pages/NoPermission'
import routes from '~/routes'
import idmRoutes from '~/routes/_IDM'

import IdmMenu from '../IdmMenu'
import Sidebar from '../Sidebar'

import useCustom from './hooks'

const CHANGE_PASSWORD_PATH = '/settings/profile'

const ProtectedLayout = () => {
  const { data } = useCustom()
  const location = useLocation()

  const firstSegment = location.pathname.split('/')[1]

  useEffect(() => {
    const pathDiProteksi = ['report-bus'] // path yang ingin kamu proteksi

    if (!pathDiProteksi.includes(firstSegment)) return

    const handleContextMenu = (e: any) => {
      e.preventDefault()
      // alert('Klik kanan dinonaktifkan di halaman ini.')
    }

    const handleKeyDown = (e: any) => {
      const key = e.key.toLowerCase()

      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && ['i', 'j', 'c'].includes(key)) ||
        (e.ctrlKey && key === 'u')
      ) {
        e.preventDefault()
        // alert('Akses Developer Tools dinonaktifkan di halaman ini.')
      }
    }

    document.addEventListener('contextmenu', handleContextMenu)
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [location.pathname])

  if (data.mustChangePwd && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Redirect to={`${CHANGE_PASSWORD_PATH}?change-password=true`} />
  }

  return (
    <Box display="flex" height="100%">
      <Sidebar />

      <InternalServerError>
        <Suspense fallback={<Loading height="100%" loading />}>
          <Switch>
            {routes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                component={route.component}
                exact={!!route.exact}
              />
            ))}

            <Route exact path="/organization">
              {data.userRoleType.isSysadmin ? (
                <Redirect to="/organization/list" />
              ) : (
                <Redirect
                  to={`/organization/detail?orgId=${data.userData?.userOrg?.orgID}`}
                />
              )}
            </Route>

            {idmRoutes.map(({ path, component: Component, exact, hideTab }) => (
              <Route
                key={path}
                path={path}
                component={() => (
                  <Box width={1} px={3} mt={6}>
                    {!hideTab && (
                      <Box mb={3}>
                        <IdmMenu />
                      </Box>
                    )}

                    <Component />
                  </Box>
                )}
                exact={!!exact}
              />
            ))}
            <Route exact path="/">
              <Redirect to={data.defaultPath as any} />
            </Route>
            <Route path="/unauthorized" component={ErrorUnauthorized} />
            <Route path="/no-permission" component={NoPermissionPage} />
            <Route path="/public-map" component={DetailMapPublicPage} />
            <Route path="/streamax/:id" component={Streamax} />
            <Route component={NotFound} />
          </Switch>
        </Suspense>
      </InternalServerError>
    </Box>
  )
}

export default memo(ProtectedLayout)
